import { render, staticRenderFns } from "./NewsUpdate.vue?vue&type=template&id=6d2e485b&"
import script from "./NewsUpdate.vue?vue&type=script&lang=js&"
export * from "./NewsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports